import { styled } from '@linaria/react';
import { Badge } from '../Badge';
import { colors, fonts, layout, semantic, space } from '../../theme/tokens';

export const CardWrapper = styled.div<{ $unavailable?: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: ${space[3]};
  padding: 20px;
  background: ${({ $unavailable }) => ($unavailable ? semantic.bg.surfaceSubtle : colors.white)};
  border: 1px solid ${semantic.border.default};
  border-radius: ${layout.borderRadiusXl};
  opacity: ${({ $unavailable }) => ($unavailable ? 0.7 : 1)};

  @media (max-width: 389px) {
    gap: ${space[2]};
    padding: ${space[4]};
  }

  @media (min-width: ${layout.desktopBreakpoint}) {
    gap: ${space[4]};
  }
`;

export const Thumbnail = styled.div`
  width: 74px;
  height: 74px;
  border-radius: ${space[1]};
  overflow: hidden;
  flex-shrink: 0;
  background: ${semantic.bg.surfaceSubtle};

  @media (max-width: 389px) {
    width: 56px;
    height: 56px;
  }

  @media (min-width: ${layout.desktopBreakpoint}) {
    width: 82px;
    height: 82px;
  }
`;

export const ThumbnailImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const ThumbnailPlaceholder = styled.div`
  width: 100%;
  height: 100%;
  background: ${semantic.bg.surfaceStrong};
`;

export const ContentColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[3]};
  flex: 1;
  min-width: 0;
`;

export const TitleRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: ${space[2]} ${space[5]};

  @media (max-width: 389px) {
    gap: ${space[2]} ${space[3]};
  }
`;

export const Name = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  line-height: 1.4;
  color: ${semantic.text.primary};
  flex: 1;
  min-width: 80px;
  overflow-wrap: break-word;

  @media (min-width: ${layout.desktopBreakpoint}) {
    font-size: ${fonts.size.base};
  }
`;

export const PriceBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex-shrink: 0;
  text-align: right;
`;

export const SecondaryPrice = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  line-height: 1.4;
  color: ${semantic.text.primary};

  @media (min-width: ${layout.desktopBreakpoint}) {
    font-size: ${fonts.size.sm};
  }
`;

export const BottomRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: ${space[2]} ${space[3]};
`;

export const DetailsButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  font-weight: ${fonts.weight.medium};
  line-height: 1.4;
  color: ${semantic.text.primary};
  text-decoration: underline;
  cursor: pointer;
  white-space: nowrap;

  &:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
  }

  @media (min-width: ${layout.desktopBreakpoint}) {
    font-size: ${fonts.size.sm};
  }
`;

export const PromotionPill = styled(Badge)`
  background: ${colors.primary};
  color: ${colors.white};
  padding: ${space[1]} ${space[3]};
  border-radius: ${layout.borderRadiusFull};
  font-weight: ${fonts.weight.medium};
  letter-spacing: normal;
  white-space: nowrap;
`;

export const UnavailableText = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${semantic.text.secondary};
`;
